import UserListLeftSection from "../../components/User/UserListLeftSection";
import UserListRightSection from "../../components/User/UserListRightSection";
import HOC from "../../components/HOC/HOC";
import HOCbuilder from "../../components/HOCbuilder/HOC";
import "./Users.scss";
import "../Dashboard/Dashboard.scss";
import AssistantPage from "../Assistants";
import UseAssistant from "../UseAssistant";
import TestSimulatorPage from "../TestSimulatorPage";
// import { useState } from "react";
function TestSimulatorPageWrapper() {
  // const [isMenuOpen, setIsMenuOpen] = useState(false);

  // const toggleMenu = () => {
  //   setIsMenuOpen(prevState => !prevState);
  // };

  return <HOCbuilder children={<TestSimulatorPage/>}/>
  // (
  //   <>
  //     <section className="dashboad-section-page">
  //       <UserListLeftSection isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
  //       <UserListRightSection  isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
  //     </section>
  //   </>
  // );
}

export default TestSimulatorPageWrapper;
